import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { PostCallEditor } from './post_call_editor';
import { PostCallToolbar } from './post_call_toolbar';
import { MilkdownProvider } from '@milkdown/react';
import { NotesToolbarContextProvider } from '../../context/notes/notes_toolbar_context';
import { EditorStateContextProvider, useEditorStateContext, } from '../../context/notes/notes_editor_state_context';
import { styled } from '../../styles';
import { Column } from '../layout/flex';
import { milkdownStyles } from './styles';
export function PostCallNotes({ captureButtonClick, defaultTemplate, noteFinalizedYn, markdownPersistedToBackend, initialMarkdown, maxCharacters, onNoteUpdated, onSave, sendNote, readOnlyYn, sendNoteEnabledYn, }) {
    return (_jsx(EditorStateContextProvider, { captureButtonClick: captureButtonClick, defaultTemplate: defaultTemplate, noteFinalizedYn: noteFinalizedYn, inCallOrPostCall: "post-call", markdownPersistedToBackend: markdownPersistedToBackend, maxCharacters: maxCharacters, onNoteUpdated: onNoteUpdated, onSave: onSave, sendNote: sendNote, initialMarkdown: initialMarkdown, readOnlyYn: readOnlyYn, sendNoteEnabledYn: sendNoteEnabledYn, children: _jsx(NotesToolbarContextProvider, { children: _jsx(MilkdownProvider, { children: _jsx(PostCallNotesView, {}) }) }) }));
}
function PostCallNotesView() {
    const { displayModeYn, currentMarkdownInEditor } = useEditorStateContext();
    return (_jsxs(NotesWrapper, { readOnlyYn: displayModeYn, "data-testid": "post-call-notes-wrapper", children: [_jsx(PostCallToolbar, { displayModeYn: displayModeYn }), _jsx(PostCallEditor, { defaultValue: currentMarkdownInEditor })] }));
}
export const NotesWrapper = styled(Column)(({ readOnlyYn, theme }) => {
    return {
        cursor: readOnlyYn ? 'not-allowed' : 'inherit',
        backgroundColor: theme.colors.grey05,
        border: `1px solid ${theme.colors.grey10}`,
        borderRadius: '.5rem',
        width: '100%',
        rowGap: 0,
        padding: '1rem',
        ...milkdownStyles,
    };
});
//# sourceMappingURL=post_call_notes.js.map